"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorsColumnsClasses = void 0;
exports.getScaleColorIndex = getScaleColorIndex;
var _styles = require("@gogame/ui/styles");
var numOfColorStops = 5;
function getScaleColorIndex(_ref) {
  var minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    value = _ref.value,
    reversed = _ref.reversed;
  var range = maxValue - minValue;
  var weight = (value - minValue) / range;
  var colorIndex = Math.max(Math.ceil(weight * numOfColorStops) - 1, 0);
  return reversed ? numOfColorStops - 1 - colorIndex : colorIndex;
}
var getColorsColumnsClasses = exports.getColorsColumnsClasses = function getColorsColumnsClasses(theme) {
  if (theme.palette.mode === 'light') {
    return [(0, _styles.blend)(theme.palette.background.paper, theme.palette.error.main, 0.9, 1), (0, _styles.blend)(theme.palette.background.paper, theme.palette.warning.light, 0.9, 1),
    //blend(theme.palette.background.paper, theme.palette.error.light, 0.8, 1),
    (0, _styles.blend)(theme.palette.background.paper, theme.palette.pending.light, 0.6, 1), (0, _styles.blend)(theme.palette.background.paper, theme.palette.success.light, 0.8, 1), (0, _styles.blend)(theme.palette.background.paper, theme.palette.success.dark, 0.9, 1)].map(function (color) {
      return [(0, _styles.blend)(theme.palette.background.paper, color, 0.3, 1), (0, _styles.blend)(theme.palette.background.paper, color, 0.5, 1)];
    });
  }
  if (theme.palette.mode === 'dark') {
    return [(0, _styles.blend)(theme.palette.background.paper, theme.palette.error.main, 0.9, 1), (0, _styles.blend)(theme.palette.background.paper, theme.palette.warning.light, 0.9, 1),
    //blend(theme.palette.background.paper, theme.palette.error.light, 0.8, 1),
    (0, _styles.blend)(theme.palette.background.paper, theme.palette.pending.light, 0.9, 1), (0, _styles.blend)(theme.palette.background.paper, theme.palette.success.light, 0.8, 1), (0, _styles.blend)(theme.palette.background.paper, theme.palette.success.dark, 0.9, 1)].map(function (color) {
      return [(0, _styles.blend)(theme.palette.background.paper, color, 0.3, 1), (0, _styles.blend)(theme.palette.background.paper, color, 0.5, 1)];
    });
  }
};